<template>
  <v-app class="nx-primary--lighten-5">
    <v-layout align-center justify-center bgcolor="secondary">
      <div class="text-xs-center">
        <img :src="imageSvg" alt="403 Error" width="377" height="377" />
        <br/>
        <h2>¡Ups!</h2>
        <p>{{ $t("message.error.notAuthorizedUrl") }}</p>
        <v-btn
          color="secondary"
          :to="{ name: 'home' }">
          {{ $t("message.common.goHome") }}
        </v-btn>
      </div>
    </v-layout>
  </v-app>
</template>

<script>
import sample from 'lodash/sample';
import BasePage from '@/pages/BasePage';
import ImageSvg from '@/assets/status/403.svg';

export default {
  name: 'nx-notfound-page',
  extends: BasePage,
  metaInfo() {
    return {
      title: '403',
      // all titles will be injected into this template
      titleTemplate: '%s | BCube CMS',
    };
  },
  computed: {
    randomGif() {
      return sample(this.gifs);
    },
  },
  data() {
    return {
      imageSvg: ImageSvg,
    };
  },
  mounted() {
    this.finishLoading();
  },
};
</script>

<style lang="stylus" scoped>

</style>
